import React, { useEffect, useState, useCallback } from 'react';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import winSatsIcon from '../images/congratsIcon1.png';
import TimerIcon from '../images/timer.png';
import Modal from "react-modal";
import { BsShareFill } from "react-icons/bs";
import { HiXMark } from "react-icons/hi2";
import * as nativeEvents from '../Helper/native';
import * as APIHelper from '../Helper/apiFetch';
import Lottie from "lottie-react";
import CongLottie from '../lottie/lottie.json';
Modal.setAppElement("#root");

const initiaData = require('./urlEncodeTest.json');

const Congratulation = ({ title, discountCode, cardType, quiz=true, rewardType, onAction, onClose, rewardTypeData, selectedType, onTypeChange, onClaimWithType, claimingWithType, cardIssued, cardPaymentStatus, ctaOverride }) => {
    const [modal, setModal] = useState(true);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [timeLeft, setTimeLeft] = useState(5);

    const getCardCtaConfig = () => {
        if (cardIssued === 'INTRO' && cardPaymentStatus) {
            return { label: 'UPGRADE CARD', action: nativeEvents.upgradeCard };
        } else if (cardIssued === 'INTRO' && !cardPaymentStatus) {
            return { label: 'PURCHASE CARD', action: nativeEvents.purchaseCard };
        } else if (cardIssued === 'NOCARD') {
            return { label: 'ACTIVATE CARD', action: nativeEvents.activateCard };
        }
        return { label: 'LOAD CARD', action: nativeEvents.loadCard };
    };

    const ctaConfig = ctaOverride ?? (() => {
        switch (rewardType) {
            case 'sc':
            case 'bonus_sc':
                return { label: 'VIEW REWARDS', action: nativeEvents.goHistory };
            case 'card_load':
            case 'card_activate_sats':
            case 'card_percentage':
            case 'card_upgrade':
            case 'elite_upgrade_discount_percentage':
            case 'card_balance':
                return getCardCtaConfig();
            case 'card_txn_multiply_sats':
                return { label: 'SPEND NOW', action: nativeEvents.goBack };
            case 'card_txn_sats':
                return { label: 'SPEND NOW', action: nativeEvents.goBack };
            case 'gold_discount_percentage':
                return { label: 'INVEST IN GOLD', action: nativeEvents.lumpsumScreen };
            case 'gold_onetime':
                return { label: 'INVEST IN GOLD', action: nativeEvents.lumpsumScreen };
            case 'voucher_sats':
                return { label: 'SHOP NOW', action: nativeEvents.offersBrands };
            case 'voucher_multiply_sats':
                return { label: 'SHOP NOW', action: nativeEvents.offersBrands };
            case 'bbps_sats':
                return { label: 'SPEND NOW', action: nativeEvents.goBack };
            case 'satspay_sats':
            case 'sats':
            case 'bonus_sats':
            default:
                return { label: 'VIEW REWARDS', action: nativeEvents.goHistory };
        }
    })();

    const navigateHome = () => {
        setModal(false);
        if (onClose) {
            onClose();
        } else {
            ctaConfig.action();
        }
        /* if(onAction) {
            onAction();
        } else {
            switch(rewardType) {
                case "card_percentage":
                case "card_upgrade":
                case "txn_satspay":
                case "txn_bbps":
                    nativeEvents.goBack();
                    break;
                case "txn":
                    nativeEvents.shopNow();
                    break;
                case "card_load":
                    nativeEvents.loadCard();
                    break;
                case "card_purchase":
                    nativeEvents.purchaseCard();
                    break;
                case "card_activate":
                    nativeEvents.activateCard();
                    break;
                default:
                    nativeEvents.goHistory();
                    break;
            }
            window.location.reload();
        } */
    }

    const shareWithFriends = () => {
        nativeEvents.shareWithFriends(initiaData.popUpShareMessage.msg);
        if(onAction) {
            onAction();
        }
    }

    const timerRef = React.useRef(null);

    const startCountdown = () => {
        clearInterval(timerRef.current);
        setTimeLeft(15);
        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    setModal(false);
                    window.location.reload();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        setIsOpen(true);
        // Only start the countdown immediately if we're opening in success mode
        if (!rewardTypeData) {
            startCountdown();
        }
        return () => {
            clearInterval(timerRef.current);
            setModal(false);
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [])

    // When the select view transitions to the success view, reset and start the timer
    useEffect(() => {
        if (rewardTypeData === null && isOpen) {
            startCountdown();
        }
    }, [rewardTypeData])

    /*  const getCard = (code) => {
         nativeEvents.purchaseCard(code);
     } */

    useEffect(() => {
        if (modal) {
            document.body.classList.add('active-model')
            document.body.style.overflow = 'hidden'
        } else {
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [modal])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: CongLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const getCard = () => {
        const toastMessage = document.getElementById("toastMessage");
        navigator.clipboard.writeText(discountCode);
        showToast(toastMessage);
    }

    function showToast(toastMessage) {
        toastMessage.classList.add("show");
        setTimeout(() => {
            nativeEvents.purchaseCard(discountCode);
            toastMessage.classList.remove("show");
        }, 2000);
    }

    return (
        <div >
            {modal && (
                <Modal
                    isOpen={isOpen}
                    closeTimeoutMS={500}
                    className="mymodal"
                    contentLabel="My dialog"
                    overlayClassName="myoverlay"
                >
                    <div className='cong'>
                        <div className='cong-Subcontainer'>
                            <div className='cong-winSatsIcon-container-wrapper'></div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div className='cong-winSatsIcon-container'>
                                    <img src={winSatsIcon} alt='Win Sats' style={{ width: '94px', height: 'auto' }} />
                                </div>
                            </div>
                            {!rewardTypeData && (
                                <div style={{
                                    position: 'absolute', top: '-15px', left: '50%',
                                    transform: 'translateX(-50%)', fontSize: '14px', color: '#000000',
                                    fontWeight: '600', zIndex: 10, backgroundColor: '#FFFFFF',
                                    padding: '5px 10px', borderRadius: '100px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'
                                }}>
                                    <img src={TimerIcon} alt='Timer' style={{ width: '18px', height: '18px' }} />
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#000000' }}>{timeLeft}s</span>
                                </div>
                            )}
                            <div style={{ position: 'relative', paddingTop: '20px' }}>
                                {rewardTypeData ? (
                                    /* ── Reward type selection view ── */
                                    <>
                                        <h1 className='cong-title' style={{ color: title?.titleColor || '#212426', paddingTop: '20px', marginBottom: '4px' }}>
                                            You've unlocked your reward.
                                        </h1>
                                        <p className='cong-subTitle' style={{ marginBottom: '16px' }}>Pick Your Reward</p>

                                        <div style={{ display: 'flex', justifyContent: 'center',alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                            {[
                                                { value: 'sats', label: 'Sats', amount: rewardTypeData?.rewardsClaimedSats?.value, unit: 'sats', icon: "https://assets.gosats.io/notification/2026/3/1774249858725" },
                                                { value: 'sc', label: 'Supercoin', amount: rewardTypeData?.rewardsClaimedSc?.value, unit: 'SC', icon: "https://assets.gosats.io/notification/2026/3/1774249859106"  }
                                            ].map(opt => (
                                                <label
                                                    key={opt.value}
                                                    onClick={() => onTypeChange && onTypeChange(opt.value)}
                                                    style={{
                                                        border: `2px solid ${selectedType === opt.value ? '#FFCDB3' : 'none'}`,
                                                        borderRadius: '12px', padding: '17px 16px', cursor: 'pointer',
                                                        backgroundColor: selectedType === opt.value ? '#1535A8' : '#1535A8',
                                                        width: '132px',
                                                        height: 'auto',
                                                        position: 'relative',
                                                    }}
                                                >
                                                    <div>
                                                        <input
                                                            type="radio"
                                                            name="rewardType"
                                                            value={opt.value}
                                                            checked={selectedType === opt.value}
                                                            onChange={() => onTypeChange && onTypeChange(opt.value)}
                                                            style={{ accentColor: '#4B2382', width: '16px', height: '16px', position: 'absolute', top: '10px', right: '10px' }}
                                                        />
                                                    </div>
                                                    <img src={opt.icon} alt={opt.label} style={{ width: '61px', height: '55px' }} />
                                                    <div style={{ fontSize: '14px', fontWeight: '700', color: '#FFFFFF', marginTop: '7px' }}>
                                                        {opt.amount} {opt.label}
                                                    </div>
                                                </label>
                                            ))}
                                        </div>

                                        <button
                                            className='cong-HomeButn'
                                            onClick={onClaimWithType}
                                            disabled={claimingWithType}
                                            style={{
                                                width: '100%', background: '#4B2382', color: '#FFFFFF',
                                                border: '1px solid rgba(255, 255, 255, 0.3)', padding: '12px',
                                                borderRadius: '4px', fontSize: '16px', fontWeight: '600',
                                                cursor: claimingWithType ? 'not-allowed' : 'pointer',
                                                opacity: claimingWithType ? 0.7 : 1,
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                                            }}
                                        >
                                            {claimingWithType
                                                ? <><ClipLoader color="#FFFFFF" size={18} /> Claiming...</>
                                                : selectedType === 'sc'
                                                    ? `CONFIRM WITH ${rewardTypeData?.rewardsClaimedSc?.value} SUPERCOIN`
                                                    : `CONFIRM WITH ${rewardTypeData?.rewardsClaimedSats?.value} SATS`
                                            }
                                        </button>
                                    </>
                                ) : (
                                    /* ── Normal congratulations view ── */
                                    <>
                                        <h1 className='cong-title' style={{ color: title?.titleColor || '#212426', paddingTop: '20px', marginBottom: '16px' }}>
                                            {title?.title}
                                        </h1>
                                        <p className='cong-subTitle' dangerouslySetInnerHTML={{ __html: title?.msg1 }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                                            <button
                                                className='cong-HomeButn'
                                                onClick={navigateHome}
                                                style={{
                                                    width: '100%', background: '#4B2382', color: '#FFFFFF',
                                                    border: '1px solid rgba(255, 255, 255, 0.3)', padding: '12px',
                                                    borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer'
                                                }}
                                            >
                                                {ctaConfig.label}
                                            </button>
                                            <button
                                                className='cong-button'
                                                onClick={() => shareWithFriends()}
                                                style={{
                                                    width: '100%', backgroundColor: 'transparent', color: '#39220B',
                                                    border: '1px solid rgba(75, 35, 130, 1)', padding: '12px',
                                                    borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                                                }}
                                            >
                                                SHARE WITH FRIENDS
                                                <BsShareFill size={16} />
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <div className=' cong-container '>
                        <div className='cong' >
                            <div className=' cong-Subcontainer'>
                                {
                                    quiz === false ?
                                        null
                                        :
                                        <div className='cong-iplStreak-container'>
                                            <Lottie
                                                options={defaultOptions}
                                                height={250}
                                                width={300}
                                                style={{ marginTop: '-93px' }}
                                            />
                                        </div>
                                }

                                <div style={{ position: 'relative' }}>
                                    <h1 className='cong-title' style={{ color: title?.shareButton === undefined ? '#FB604A' : '#000000', paddingTop: quiz === false ? '20px' : '130px' }}>{title?.title}</h1>
                                    <p className='cong-subTitle' dangerouslySetInnerHTML={{ __html: title?.msg1 }} />
                                    {
                                        quiz === false ?
                                            <div>
                                                <button className='cong-HomeButn' onClick={navigateHome}>{title?.doneButton}</button>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div>
                                    {
                                        quiz === false ?
                                            null
                                            :
                                            <div>
                                                <div className='congDivider'>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div className="congPopUpTitle">
                                                        Share with your friends and earn more!
                                                    </div>
                                                    <div>
                                                        {
                                                            cardType === "undefined" ?
                                                                <div>
                                                                    <button className='cong-button' onClick={() => shareWithFriends()}>{title?.shareButton}<BsShareFill size={16} /></button>
                                                                </div>
                                                                :
                                                                <div>
                                                                    {cardType === "undefined" ? <button className='cong-button' onClick={() => getCard()}>{title?.getCard}</button> : <button className='cong-button' onClick={() => shareWithFriends()}>{title?.shareButton}<BsShareFill size={16} /></button>}
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                            {
                                quiz === false ?
                                    null
                                    :
                                    <div>
                                        {
                                            discountCode != undefined ?
                                                <div>
                                                    <button className='shareCong-button' onClick={() => getCard(discountCode)}>{title?.getCard}</button>
                                                </div>
                                                :
                                                <div>
                                                    <button className='cong-HomeButn mb-4' onClick={navigateHome}>{title?.doneButton}</button>
                                                </div>
                                        }

                                    </div>
                            }
                        </div>
                        <div class="toast" id="toastMessage" style={{width:'maxContent'}}>Coupon Code copied to clipboard</div>
                    </div> */}
                </Modal>
            )}
        </div>
    );
}

export default Congratulation;


